module.exports = __webpack_public_path__ + "files/0e9ad638b207660e7f3c874b13bb8241.png";